window.greetingCardState = window.greetingCardState || {
  active: false,
  message: ''
};

class GreetingCardToggle extends HTMLElement {
  connectedCallback() {
    this._controller = new AbortController();
    const { signal } = this._controller;
    this.maxLength = 200;
    this.refs = {};
    this.querySelectorAll('[ref]').forEach(el => { this.refs[el.getAttribute('ref')] = el; });
    this.addEventListener('change', event => {
      if (event.target === this.getCheckbox()) this.handleCheckboxChange(event);
    }, { signal });
    this.addEventListener('input', event => {
      if (event.target === this.getMessageInput()) this.handleInput(event);
    }, { signal });
    this.closest('form')?.addEventListener('reset', () => this._onFormReset(), { signal });
    window.addEventListener('greeting-card:updated', () => this.syncState(), { signal });
    this.syncState();
  }

  disconnectedCallback() {
    this._controller?.abort();
    this._externalController?.abort();
    this._boundExternalInput = null;
  }

  /** Rebind after a variant morph and restore Main ↔ Sticky state without resetting the draft. */
  syncState() {
    this.refs = {};
    this.querySelectorAll('[ref]').forEach(el => { this.refs[el.getAttribute('ref')] = el; });
    const section = this.closest('.shopify-section');
    this.hiddenPropertyInput = section?.querySelector('#main-greeting-card-property') || document.getElementById('main-greeting-card-property');
    const input = this.getMessageInput();
    if (input !== this._boundExternalInput) {
      this._externalController?.abort();
      this._boundExternalInput = input;
      if (input && !this.contains(input)) {
        this._externalController = new AbortController();
        input.addEventListener('input', event => this.handleInput(event), { signal: this._externalController.signal });
      }
    }
    this._restoreState();
  }

  getCheckbox() {
    return this.querySelector('.greeting-card__checkbox') || this.refs.checkbox;
  }

  getContainer() {
    const targetSelector = this.getAttribute('data-target-input');
    if (targetSelector) {
      return this.closest('.shopify-section')?.querySelector(targetSelector) || document.querySelector(targetSelector);
    }
    return this.refs.inputContainer;
  }

  getMessageInput() {
    const container = this.getContainer();
    if (!container) return null;
    return container.querySelector('textarea, input') || this.refs.messageInput;
  }

  _restoreState() {
    const { active, message } = window.greetingCardState;
    const checkbox = this.getCheckbox();
    const container = this.getContainer();
    const input = this.getMessageInput();

    if (checkbox) {
      checkbox.checked = Boolean(active);
    }

    if (this.hiddenPropertyInput) {
      this.hiddenPropertyInput.disabled = !active;
      this.hiddenPropertyInput.value = active ? message : '';
    }

    if (container) {
      if (active) {
        container.removeAttribute('hidden');
        container.classList.add('is-visible');
      } else {
        container.setAttribute('hidden', '');
        container.classList.remove('is-visible');
      }
    }

    if (input && input.value !== message) {
      input.value = active ? message : '';
    }

    this.updateCounter(active ? message.length : 0);
  }

  _onFormReset() {
    setTimeout(() => {
      window.greetingCardState.active = false;
      window.greetingCardState.message = '';
      window.dispatchEvent(new CustomEvent('greeting-card:updated'));
    }, 0);
  }

  _onStateUpdate() {
    this._restoreState();
  }

  handleCheckboxChange(event) {
    const checkbox = this.getCheckbox();
    const isChecked = checkbox ? checkbox.checked : false;

    window.greetingCardState.active = isChecked;
    if (!isChecked) {
      window.greetingCardState.message = '';
    }

    this._restoreState();

    // Синхронізуємо інші компоненти листівки (якщо є в main і в sticky)
    window.dispatchEvent(new CustomEvent('greeting-card:updated'));

    this.dispatchEvent(
      new CustomEvent('greeting-card:toggle', {
        bubbles: false,
        composed: true,
        detail: { active: isChecked },
      })
    );
  }

  handleInput(event) {
    const value = event.target.value.slice(0, this.maxLength);
    event.target.value = value;

    window.greetingCardState.message = value;

    if (this.hiddenPropertyInput && window.greetingCardState.active) {
      this.hiddenPropertyInput.value = value;
    }

    this.updateCounter(value.length);

    // Оновлюємо значення в іншому інпуті, якщо вони продубльовані
    window.dispatchEvent(new CustomEvent('greeting-card:updated'));
  }

  updateCounter(length) {
    const container = this.getContainer();
    const counter = container?.querySelector('[data-counter]') || this.refs.counter;
    if (counter) {
      counter.textContent = `${length}/${this.maxLength}`;
    }
  }
}

if (!customElements.get('greeting-card-toggle')) {
  customElements.define('greeting-card-toggle', GreetingCardToggle);
}
